import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicios",
    },
    {
        path: "/servicios/entrenamiento",
        label: "Entrenamiento",
    },
    {
        path: "/editar",
        label: "Editar",
        isActive: true
    }
]

function EditarServicioEntrenamiento(){
    return (
        <Page title="Edición de servicio de entrenamiento" description="Modificación de planes de entrenamiento." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default EditarServicioEntrenamiento;